/* eslint-disable */
import {CognitoAuth, StorageHelper} from 'amazon-cognito-auth-js';
//import {CognitoUserPool, CognitoUserAttribute } from 'amazon-cognito-identity-js';
//var AmazonCognitoIdentity = require('amazon-cognito-identity-js')
import IndexRouter from '@/router';
import UserInfoStore from './user-info-store';
import UserInfoApi from './user-info-api';


const CLIENT_ID = process.env.VUE_APP_COGNITO_CLIENT_ID;
const APP_DOMAIN = process.env.VUE_APP_COGNITO_APP_DOMAIN;
const REDIRECT_URI = process.env.VUE_APP_COGNITO_REDIRECT_URI;
const USERPOOL_ID = process.env.VUE_APP_COGNITO_USERPOOL_ID;
const REDIRECT_URI_SIGNOUT = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT;
const APP_URL = process.env.VUE_APP_APP_URL;

var authData = {
    ClientId : CLIENT_ID, // Your client id here
    AppWebDomain : APP_DOMAIN,
    TokenScopesArray : ['openid', 'email', 'profile'],
    RedirectUriSignIn : REDIRECT_URI,
    RedirectUriSignOut : REDIRECT_URI_SIGNOUT,
    UserPoolId : USERPOOL_ID,
}

/** Mapping security group guid with the group names **/
let security_group_mappings = new Map([
  ["e48f7354-4413-4d0a-bd4a-245bd16e6481", "VoucherAdmin"],
  ["1eccf7a3-5d6f-48ef-aa47-9f1dc1b3764f", "VoucherDefault"],
  ["f208d42a-da75-414b-b666-dbb72ce88b9e", "VoucherPharmacy"],
  ["bcfa0f45-b166-4ccd-9881-54829d4612e0", "VoucherReporting"]
]
);

var auth = new CognitoAuth(authData);

auth.userhandler = {
    onSuccess: function(result) {
        //console.log("On Success result", result);
        UserInfoStore.setLoggedIn(true);
        //console.log("Routing getUserInfo ..");

        UserInfoApi.getUserInfo().then(response => {
            //console.log("User Data Response: ", response);
            // convert all custom: to custom_ as cognito stores custom attributes as colons
            var responseStr = JSON.stringify(response).replace(/custom:/g, "custom_");
  //          console.log("Response Str", responseStr);
            var responseObj = JSON.parse(responseStr);// back to object
            UserInfoStore.setUserEmail(response.email);

            /* User security group explained below -
              •	Administrative Users: These are users who belong to the 'VoucherAdmin' security group set up in AD.
              This security groups allows this user full access to the voucher portal allowing to create and maintain customers, pharmacies,
              products and create contracts to issue vouchers and record vaccinations against these contracts.

              •	Voucher ReadOnly Users: These are users who belong to the 'VoucherAdmin' security group (same as above) set up in AD. However, users
              only have readonly access to all areas of the flu voucher portal. Users can only view products, customers, contracts and vaccinations
              created but cannot create/update or delete any records.          

              •	Pharmacy Users: These are users who belong to the 'VoucherPharmacy' security group set up in AD.
              This security group allows users (pharmacist) to only record vaccinations and view reports.
              The application will allow to record vaccinations against previously created contracts.

              •	Reports Users: These are users who belong to the 'VoucherReporting' security group set up in AD.
               This security group allows users to only view reports on number of vaccinations and contracts issued.

              •	No Access: These users are not part of any security group and hence don't have access to any part of the voucher application,
               once this user is successfully authenticated. We may look to provide some access to the portal in future. However, for the moment, voucher access is restricted to this user.
            */
            //console.log("Has Security group: ", security_group_mappings.has(responseObj.custom_user_security_group));
            //console.log("security group: ", security_group_mappings.get(responseObj.custom_user_security_group));
            UserInfoStore.setUserGroup(security_group_mappings.get(responseObj.custom_user_security_group));
            // the branch name is set to be the name of the pharmacy or 'Head Office'
            UserInfoStore.setBranchName(responseObj.custom_branch_name);
            IndexRouter.push('/');
        });
    },

    onFailure: function(err) {
        UserInfoStore.setLoggedOut();
        IndexRouter.go({ path: '/error', query: { message: 'Login failed due to ' + err } });
    }
};

function getUserInfoStorageKey(){
    //console.log("In getUserInfoStorageKey method");
    var keyPrefix = 'CognitoIdentityServiceProvider.' + auth.getClientId();
    var tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
    var userInfoKey = keyPrefix + '.' + tokenUserName + '.userInfo';
    //console.log("UserInfoKey: ", userInfoKey);
    return userInfoKey;
    }

function userLogout(){
//  console.log("userLogout ..");
    var storageHelper = new StorageHelper();
    var storage = storageHelper.getStorage();
    if (auth.isUserSignedIn()) {
        var userInfoKey = getUserInfoStorageKey();
        auth.signOut();
        storage.removeItem(userInfoKey);
    }
}

//var storageHelper = new StorageHelper();
//var storage = storageHelper.getStorage();
export default{
    auth: auth,
    userLogout,
    login(){
        //console.log("In Login ..");
        auth.getSession();
    },

    logout(){
//      console.log("In Logout ..");
        userLogout();
    },
    getUserInfoStorageKey,

}
